import { TableRow, TableCell, IconButton, Collapse, Box, Typography, Table, TableHead, TableBody, Chip } from "@mui/material";
import React from "react";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HelpIcon from '@mui/icons-material/Help';
import CancelIcon from '@mui/icons-material/Cancel';
import { compareRoundSolves, countLossesForRound, countWinsForRound, getAverageTimeForRound, getFastestTimeForRound, ROUND_STATUS, RoundSolve } from "./utils/MatchUtils";
import { formatTime } from "../hooks/useSolve";

interface RoundRowProps {
    roundNumber: number,
    solves: RoundSolve[],
    opponentSolves: RoundSolve[],
    showScramble: boolean,
    currentRound: number,
    currentSolve: number,
    adminActions: boolean
}

const RoundRow: React.FC<RoundRowProps> = ({ roundNumber, solves, showScramble, opponentSolves, currentRound, currentSolve, adminActions }) => {
    const [open, setOpen] = React.useState(roundNumber === currentRound);

    const rounds = compareRoundSolves(solves, opponentSolves)
    const wins = countWinsForRound(rounds, roundNumber)
    const losses = countLossesForRound(rounds, roundNumber)
    const fastest = getFastestTimeForRound(solves, roundNumber)
    const average = getAverageTimeForRound(solves, roundNumber)

    return (
        <React.Fragment>
            <TableRow sx={{ '& > *': { borderBottom: 'unset' }, bgcolor: "rgba(0, 0, 0, 0.08)" }}>
                <TableCell>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => setOpen(!open)}
                    >
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell component="th" scope="row">Round {roundNumber + 1}</TableCell>
                <TableCell>{fastest === null ? "--" : formatTime(fastest)}</TableCell>
                <TableCell>{average === null ? "--" : formatTime(average)}</TableCell>
                <TableCell align="center" component="th" scope="row">{wins}</TableCell>
                <TableCell align="center" component="th" scope="row">{losses}</TableCell>
                <TableCell component="th" scope="row">
                    {wins > 2 && <CheckCircleIcon color="success" />}
                    {losses > 2 && <CancelIcon color="error" />}
                    {wins < 3 && losses < 3 && <HelpIcon color="disabled" />}
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box sx={{ margin: 1 }}>
                            {/* <Typography variant="h6" gutterBottom component="div">
                  Solves
                </Typography> */}
                            <Table size="small" aria-label="purchases">
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ fontWeight: 600 }}>Solve</TableCell>
                                        <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
                                        <TableCell align="right" sx={{ fontWeight: 600 }}>Time</TableCell>
                                        {showScramble && <TableCell sx={{ fontWeight: 600 }}>Scramble</TableCell>}
                                        {adminActions && <TableCell sx={{ fontWeight: 600 }}>Actions</TableCell>}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {solves.map((solve) => (
                                        <TableRow key={`${solve.roundNumber}-${solve.solveNumber}`} selected={currentRound === solve.roundNumber && currentSolve === solve.solveNumber}>
                                            <TableCell component="th" scope="row" align="center">{solve.solveNumber + 1}</TableCell>
                                            <TableCell><Chip size="small" label={solve.status} /></TableCell>
                                            <TableCell align="right">{solve.solveTime == null ? "--" : formatTime(solve.solveTime)}</TableCell>
                                            {showScramble && <TableCell>
                                                {solve.status === ROUND_STATUS.SolveVerified ? solve.scramble : "* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *"}
                                            </TableCell>}
                                            {adminActions && <TableCell>

                                            </TableCell>}   
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}

export default RoundRow;